import { useEffect, useState } from "react";

import { getSvcSettingsClient, type SettingsGroup } from "../client/svcSettings";

const ASPEN_SETTINGS_GROUP = "aspen";
const ASPEN_GLOBAL_SETTINGS_GROUP = "aspen.global";
const ENABLE_ASPEN_GLOBALLY = "enableAspenGlobally";

export const getAspenGlobalEnabled = (groups: SettingsGroup[]): boolean => {
  const aspenGlobalGroup = groups.find(group => group.groupName === ASPEN_GLOBAL_SETTINGS_GROUP);
  return aspenGlobalGroup?.values?.[ENABLE_ASPEN_GLOBALLY] !== false;
};

export function useAspenGlobalEnabled(tenantName: string | null | undefined) {
  const [aspenGloballyEnabled, setAspenGloballyEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(Boolean(tenantName));

  useEffect(() => {
    if (!tenantName) {
      setAspenGloballyEnabled(true);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setAspenGloballyEnabled(false);
    setIsLoading(true);

    const load = async () => {
      try {
        const { promise } = getSvcSettingsClient().getTenantSettings(
          tenantName,
          ASPEN_SETTINGS_GROUP
        );
        const settings = await promise;
        if (cancelled) return;

        setAspenGloballyEnabled(getAspenGlobalEnabled(settings?.groups ?? []));
      } catch (error) {
        console.error("Error fetching Aspen global setting:", error);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [tenantName]);

  return { aspenGloballyEnabled, isLoading };
}
